import PaymentTypeAPI from "../../../api/PaymentTypeAPI";
import PaymentType from '../../../models/paymentType/PaymentType';

export default {
  async loadAllPaymentTypes({
    commit
  }) {
    const response = await new PaymentTypeAPI().all();
    let result = [];
    for (let i = 0; i < response.length; i++) {
      const element = response[i];
      result.push(PaymentType.createFromData(element));
    }

    commit("SET_ALL_PAYMENT_TYPES", result);
  },
};
